/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import { Flex, Button } from '@fluentui/react-northstar'
import { Text } from '@fluentui/react-northstar'

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
            <Flex gap="gap.small" padding="padding.medium">
                <Flex.Item grow>
                    <Flex>
                        <img
                            src="/flinker-logo-text.png"
                            width="auto"
                            height="25"
                            alt="Flinker logo"
                        />
                        <Text weight="semibold" size="large" content="Studio" />
                    </Flex>
                </Flex.Item>
                <Flex.Item push>
                    {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                </Flex.Item>

            </Flex>
            {props.children}
        </>
    );
};
